import React from 'react';
import './App.css';
import Hero from './components/Hero';
import EventDetails from './components/EventDetails';
import RegistrationForm from './components/RegistrationForm';
import WhatsAppButton from './components/WhatsAppButton';

function App() {
  return (
    <div className="App">
      <Hero />
      <EventDetails />
      <RegistrationForm />
      <WhatsAppButton />
    </div>
  );
}

export default App;